import React from "react";
import { Grid, Paper, Avatar, Typography, Divider } from "@mui/material";
import DashboardPageHeader from "../../components/includes/DashboardPageHeader";
import SearchBar from "../../components/includes/SearchBar";
import { useEffect } from "react";
import {
    collection,
    query,
    where,
    orderBy,
    onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useState } from "react";
import { authors } from "../../data";

const Redacteurs = () => {
    const [applicants, setApplicants] = useState(null);
    const [data, setData] = useState(null);
    const [search, setSearch] = useState(null);

    const searchFilter = (text) => {
        const newData =
            authors &&
            authors.filter((item) => {
                const itemData = item
                    ? item.toUpperCase()
                    : "".toUpperCase();
                const textData = text.toUpperCase();
                return itemData.indexOf(textData) > -1;
            });
        setSearch(text);
        setData(newData);
    };

    return (
        <main>
            <Grid sx={{ p: 3 }} container spacing={2}>
                <Grid item xs={12}>
                    <DashboardPageHeader title={"Candidats"} />
                </Grid>
                <Grid item xs={12}>
                    <SearchBar
                        searchFilter={searchFilter}
                        placeholder={"Rechercher un candidat..."}
                    />
                </Grid>
            </Grid>
            <Grid
                direction={"row"}
                justifyContent={"center"}
                container
                sx={{ p: 3 }}
                spacing={2}
            >
                {authors &&
                    authors.map((author) => (
                        <Grid
                            sx={{ p: 3, backgroundColor: "white" }}
                            spacing={2}
                            container
                            item
                            xs={12}
                        >
                            <Grid
                                container
                                direction={"row"}
                                justifyContent={"center"}
                                item
                                xs={12}
                                md={4}
                            >
                                <Avatar
                                    src={'applicant && applicant.photoURL'}
                                    sx={{ width: 50, height: 50 }}
                                />
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography component={'a'} href={"/redacteurs/" + author} variant="p">
                                    {author}
                                </Typography>
                            </Grid>
                            <Divider />
                        </Grid>
                    ))}
            </Grid>
        </main>
    );
};

export default Redacteurs;
